import React, {createContext, useContext, useState, useRef} from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState(null);
    const [isLeaving, setIsLeaving] = useState(false);
    const timerRef = useRef(null);

    const hideToast = () => {
        setIsLeaving(true);

        setTimeout(() => {
            setToast(null);
            setIsLeaving(false);
        }, 3000);
    };

    const showToast = (message, type = 'info', duration = 3000) => {
        if (timerRef.current) clearTimeout(timerRef.current);

        setIsLeaving(false);
        setToast({ message, type });

        if (duration > 0) {
            timerRef.current = setTimeout(() => {
                hideToast();
            }, duration);
        }
    };


    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            {children}
            {toast && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 9999,
                    padding: '12px 16px 12px 20px',
                    borderRadius: '10px',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                    color: '#ffffff',
                    fontWeight: '600',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    backgroundColor:
                        toast.type === 'success' ? '#10B981' :
                            toast.type === 'error' ? '#EF4444' : '#0099aa',
                    opacity: isLeaving ? 0 : 1,
                    transform: isLeaving ? 'translateY(-20px)' : 'translateY(0)',
                    transition: 'all 0.4s ease-in-out'
                }}>
                    <span>
                        {toast.type === 'success' && '✅'}
                        {toast.type === 'error' && '⚠️'}
                        {toast.type === 'info' && 'ℹ️'}
                    </span>

                    <span>{toast.message}</span>

                    {/* Przycisk zamykania */}
                    <button
                        onClick={hideToast}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#ffffff',
                            fontSize: '1.2rem',
                            cursor: 'pointer',
                            marginLeft: '10px',
                            padding: '0 4px',
                            lineHeight: '1'
                        }}
                    >
                        ✕
                    </button>
                </div>
            )}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);